var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"Resumo"}}),_c('v-row',{staticClass:"px-3"},[_c('v-col',[_c('course-calendar',{attrs:{"use_with_menu":true}})],1),_c('v-col',[_c('next-courses')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }